import React from 'react';
import { PageStructure } from "../../pages";
import {
    LocationOrder as LocationOrderComponent
} from "../../components";

const LocationOrder = () => {
    return (
        <PageStructure>
            <LocationOrderComponent />
        </PageStructure>
    );
};

export default LocationOrder;